"use client";

import { Sparkles } from "lucide-react";
import { Button } from "@/components/shadcn/button";
import { useAtom, useAtomValue } from "jotai";
import { genieOpenAtom, geniePanelExitedAtom } from "@/store/genie-atoms";
import { useEffect } from "react";
import { isEditableTarget } from "@/utils/isEditableTarget";

export function GenieToggleButton() {
  const [isOpen, setIsOpen] = useAtom(genieOpenAtom);
  const panelExited = useAtomValue(geniePanelExitedAtom);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "i") {
        if (isEditableTarget(e.target)) return;
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [setIsOpen]);

  if (isOpen || !panelExited) return null;

  return (
    <Button
      onClick={() => setIsOpen(true)}
      aria-label="Ask Genie"
      data-genie-toggle=""
      className="group fixed bottom-2 right-2 z-2147483647 flex h-8 w-auto items-center gap-0 rounded-md border-0 px-2 shadow-lg pointer-events-auto"
    >
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium opacity-0 transition-all duration-300 ease-out group-hover:mr-1.5 group-hover:max-w-24 group-hover:opacity-100">
        Ask Genie
      </span>
      <Sparkles className="size-4 shrink-0" />
    </Button>
  );
}
